import { classNamePrefix } from '../globals';

export function renderLink (url: string, label: string, target = '_self', parentClass?: string) {
    const className = classNamePrefix + '-link';

    const linkElement = document.createElement('a');
    linkElement.classList.add(className);
    linkElement.href = url;
    linkElement.target = target;
    linkElement.innerHTML = label;

    if (parentClass) {
        linkElement.classList.add(parentClass);
    }

    return linkElement;
}